export const jobType = [
    {
        "id": 13,
        "count": 0,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/clinic-manager/",
        "name": "Clinic Manager",
        "slug": "clinic-manager",
        "taxonomy": "joblisting_job_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/13"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=13"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 15,
        "count": 18,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/locum/",
        "name": "Locum",
        "slug": "locum",
        "taxonomy": "joblisting_job_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/15"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=15"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 323,
        "count": 8,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/moa/",
        "name": "MOA",
        "slug": "moa",
        "taxonomy": "joblisting_job_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/323"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=323"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 17,
        "count": 40,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/permanent/",
        "name": "Permanent",
        "slug": "permanent",
        "taxonomy": "joblisting_job_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/17"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=17"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 324,
        "count": 7,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/teaching-opportunities/",
        "name": "Teaching Opportunities",
        "slug": "teaching-opportunities",
        "taxonomy": "joblisting_job_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/324"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=324"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    }
]

export const community = [
    {
        "id": 315,
        "count": 10,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/all-victoria/",
        "name": "All Victoria",
        "slug": "all-victoria",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/315"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=315"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 319,
        "count": 2,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/brentwood-bay/",
        "name": "Brentwood Bay",
        "slug": "brentwood-bay",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/319"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=319"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 321,
        "count": 2,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/cordova-bay/",
        "name": "Cordova Bay",
        "slug": "cordova-bay",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/321"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=321"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 92,
        "count": 5,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/downtown/",
        "name": "Downtown",
        "slug": "downtown",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/92"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=92"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 85,
        "count": 7,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/fairfield/",
        "name": "Fairfield",
        "slug": "fairfield",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/85"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=85"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 87,
        "count": 8,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/fernwood/",
        "name": "Fernwood",
        "slug": "fernwood",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/87"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=87"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 90,
        "count": 5,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/gordon-head/",
        "name": "Gordon Head",
        "slug": "gordon-head",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/90"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=90"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 81,
        "count": 1,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/interurban/",
        "name": "Interurban",
        "slug": "interurban",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/81"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=81"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 88,
        "count": 2,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/james-bay/",
        "name": "James Bay",
        "slug": "james-bay",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/88"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=88"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 317,
        "count": 2,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/langford/",
        "name": "Langford",
        "slug": "langford",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/317"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=317"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 89,
        "count": 9,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/oak-bay/",
        "name": "Oak Bay",
        "slug": "oak-bay",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/89"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=89"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 86,
        "count": 9,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/oaklands/",
        "name": "Oaklands",
        "slug": "oaklands",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/86"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=86"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 83,
        "count": 5,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/quadra/",
        "name": "Quadra",
        "slug": "quadra",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/83"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=83"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 316,
        "count": 10,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/saanich/",
        "name": "Saanich",
        "slug": "saanich",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/316"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=316"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 91,
        "count": 1,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/shelbourne/",
        "name": "Shelbourne",
        "slug": "shelbourne",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/91"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=91"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 318,
        "count": 2,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/sidney/",
        "name": "Sidney",
        "slug": "sidney",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/318"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=318"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 84,
        "count": 1,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/swan-lake/",
        "name": "Swan Lake",
        "slug": "swan-lake",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/84"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=84"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 82,
        "count": 8,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/tillicum/",
        "name": "Tillicum",
        "slug": "tillicum",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/82"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=82"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 93,
        "count": 1,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/vic-west/",
        "name": "Vic West",
        "slug": "vic-west",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/93"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=93"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 320,
        "count": 2,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_community/view-royal/",
        "name": "View Royal",
        "slug": "view-royal",
        "taxonomy": "joblisting_community",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/320"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=320"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    }
]

export const practiceType = [
    {
        "id": 100,
        "count": 8,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_practice_type/clinic-staff/",
        "name": "Clinic Staff",
        "slug": "clinic-staff",
        "taxonomy": "joblisting_practice_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type/100"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_practice_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_practice_type=100"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 98,
        "count": 62,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_practice_type/family-physician/",
        "name": "Family Physician",
        "slug": "family-physician",
        "taxonomy": "joblisting_practice_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type/98"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_practice_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_practice_type=98"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 99,
        "count": 4,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_practice_type/nurse-practitioner/",
        "name": "Nurse Practitioner",
        "slug": "nurse-practitioner",
        "taxonomy": "joblisting_practice_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type/99"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_practice_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_practice_type=99"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    }
]

export const fullPartTime = [
    {
        "id": 32,
        "count": 45,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_ft_pt/full-time-2/",
        "name": "Full-Time",
        "slug": "full-time-2",
        "taxonomy": "joblisting_ft_pt",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_ft_pt/32"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_ft_pt"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_ft_pt"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_ft_pt=32"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 31,
        "count": 53,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_ft_pt/full-time/",
        "name": "Part-Time",
        "slug": "full-time",
        "taxonomy": "joblisting_ft_pt",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_ft_pt/31"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_ft_pt"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_ft_pt"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_ft_pt=31"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    }
]

export const clinicType = [
    {
        "id": 19,
        "count": 3,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/community-health-centre-chc/",
        "name": "Community Health Centre (CHC)",
        "slug": "community-health-centre-chc",
        "taxonomy": "joblisting_clinic_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/19"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=19"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 20,
        "count": 37,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/family-practice/",
        "name": "Family Practice",
        "slug": "family-practice",
        "taxonomy": "joblisting_clinic_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/20"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=20"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 21,
        "count": 13,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/family-practice-and-walk-in-hybrid/",
        "name": "Family Practice and Walk-In Hybrid",
        "slug": "family-practice-and-walk-in-hybrid",
        "taxonomy": "joblisting_clinic_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/21"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=21"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 342,
        "count": 1,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/local-initiatives/",
        "name": "Local Initiatives",
        "slug": "local-initiatives",
        "taxonomy": "joblisting_clinic_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/342"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=342"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 22,
        "count": 1,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/long-term-care-home/",
        "name": "Long Term Care Home",
        "slug": "long-term-care-home",
        "taxonomy": "joblisting_clinic_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/22"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=22"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 322,
        "count": 7,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/teaching-opportunities/",
        "name": "Teaching Opportunities",
        "slug": "teaching-opportunities",
        "taxonomy": "joblisting_clinic_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/322"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=322"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 23,
        "count": 1,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/urgent-primary-care-centre-upcc/",
        "name": "Urgent Primary Care Centre (UPCC)",
        "slug": "urgent-primary-care-centre-upcc",
        "taxonomy": "joblisting_clinic_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/23"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=23"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    },
    {
        "id": 24,
        "count": 11,
        "description": "",
        "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/walk-in-clinic/",
        "name": "Walk-in Clinic",
        "slug": "walk-in-clinic",
        "taxonomy": "joblisting_clinic_type",
        "parent": 0,
        "meta": [],
        "acf": [],
        "_links": {
            "self": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/24"
                }
            ],
            "collection": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
                }
            ],
            "about": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
                }
            ],
            "wp:post_type": [
                {
                    "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=24"
                }
            ],
            "curies": [
                {
                    "name": "wp",
                    "href": "https://api.w.org/{rel}",
                    "templated": true
                }
            ]
        }
    }
]

/*


// Get the current site URL
const siteURL = window.location.origin;

// Define the taxonomy rest base
const taxonomyRestBase = 'joblisting_clinic_type'; // Replace 'your_taxonomy_rest_base' with the rest base of your taxonomy

// Function to fetch terms of a taxonomy
function fetchTerms() {
    fetch(`${siteURL}/wp-json/wp/v2/${taxonomyRestBase}`)
        .then(response => response.json())
        .then(terms => {
            // Process the terms here
            processTerms(terms);
        }).catch(error => console.error('Error:', error));
}

// Function to process terms
function processTerms(terms) {
    const processedTerms = terms.map(term => {
        return {
            id: term.id,
            count: term.count,
            description: term.description,
            link: term.link,
            name: term.name,
            slug: term.slug,
            taxonomy: term.taxonomy,
            parent: term.parent,
            meta: term.meta,
            acf: term.acf, // Assuming ACF plugin is used and these fields are available
            _links: term._links
        };
    });

    console.log(processedTerms);
}

// Trigger the fetch operation
fetchTerms();


*/


// WEBPACK FOOTER //
// ./src/databaseTaxonomy.js